import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-fbad7710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-switcher" }
const _hoisted_2 = ["id", "name", "disabled"]
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isModalChecked) = $event)),
      type: "checkbox",
      id: _ctx.name,
      class: "ui-switcher__input",
      name: _ctx.name,
      disabled: _ctx.isDisable
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.isModalChecked]
    ]),
    _createElementVNode("label", {
      for: _ctx.name,
      class: "ui-switcher__label"
    }, null, 8, _hoisted_3)
  ]))
}